import BasicModal from "@/modules/common/components/modals/basic-modal";
import ModalFooter from "@/modules/common/components/modals/modal-footer";
import ModalHeader from "@/modules/common/components/modals/modal-header";
import { Box, SxProps } from "@mui/material";

interface EditFieldModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  handleConfirm?: () => void;
  isLoading?: boolean;
  children: React.ReactNode;
  disabledConfirmButton?: boolean;
  header?: string | React.ReactNode;
  width?: number;
  confirmText?: string;
  cancelText?: string;
  enableEnterKeySubmit?: boolean;
  handleCloseModal?: () => void;
  modalFooter?: boolean;
  cancelButton?: JSX.Element;
  applyButton?: JSX.Element;
  padding?: string;
  gap?: number;
  showCancelButton?: boolean;
  clearButton?: JSX.Element;
  cancelButtonSx?: SxProps;
  applyButtonSx?: SxProps;
  modalSx?: SxProps;
  ref?: React.Ref<HTMLDivElement>;
  testId?: string;
}

const EditFieldModal = ({
  open,
  setOpen,
  handleConfirm = () => {},
  isLoading,
  children,
  disabledConfirmButton,
  header = "",
  width,
  confirmText,
  cancelText,
  enableEnterKeySubmit = true,
  handleCloseModal,
  modalFooter = true,
  cancelButton,
  applyButton,
  padding = "32px",
  gap = 3,
  showCancelButton = true,
  clearButton,
  cancelButtonSx,
  applyButtonSx,
  modalSx,
  ref,
  testId,
}: EditFieldModalProps) => {
  const handleClose = () => {
    setOpen(false);
    handleCloseModal && handleCloseModal();
  };

  return (
    <BasicModal
      width={width}
      open={open}
      setOpen={setOpen}
      onClose={handleClose}
      sx={modalSx}
    >
      <Box
        ref={ref}
        data-testid={testId}
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          gap,
          overflowY: "auto",
          overflowX: "hidden",
          padding: padding,
        }}
      >
        <ModalHeader headerText={header} handleClose={handleClose} />

        {children}
        {modalFooter && (
          <ModalFooter
            cancelButton={cancelButton}
            applyButton={applyButton}
            handleClose={handleClose}
            handleConfirm={handleConfirm}
            isSubmitting={isLoading}
            disabledConfirmButton={disabledConfirmButton}
            confirmText={confirmText ? confirmText : "Save"}
            cancelText={cancelText ? cancelText : "Cancel"}
            enableEnterKeySubmit={enableEnterKeySubmit}
            showCancelButton={showCancelButton}
            clearButton={clearButton}
            cancelButtonSx={cancelButtonSx}
            applyButtonSx={applyButtonSx}
          />
        )}
      </Box>
    </BasicModal>
  );
};

export default EditFieldModal;
